import React from 'react';
import classNames from 'classnames';
import errorIcon from '../ASUPhotos/icons/errorIcon.svg';
import '../sass/modules/utility/errorMessage.scss';

function ErrorMessage(props) {
  return (
    <div
      id={props.id}
      style={{ display: props.hidden ? 'none' : '' }}
      className="error-message"
    >
      <div
        className="error-icon"
        style={{
          backgroundImage: `url(${errorIcon})`,
          backgroundRepeat: 'no-repeat',
        }}
      />
      <p
        className={classNames({
          'error-text': true,
          'duplicate-sso-email': props.duplicateSSOEmail,
        })}
      >
        {props.error}
      </p>
    </div>
  );
}

export default ErrorMessage;
